import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { SynchronizationLogin } from "./Synchronization";
import * as syncActions from "./actions";
import { getSyncedHotels } from "../hotels/selectors";
import { translate } from "react-i18next";
import { getMessageVisibility } from "../messages/selectors";
import { toggleMessage } from "../messages/actions";
import { isSynchronizing } from "../users/selectors";
class SynchronizationContainer extends Component {
  componentDidMount() {
    this.props.getSyncUser();
  }
  render() {
    return <SynchronizationLogin {...this.props} />;
  }
}
const mapStateToProps = state => ({
  ...state.synchronization,
  syncedHotels: getSyncedHotels(state),
  isSynchronizing: isSynchronizing(state),
  synchronizationInfoMessageVisible: getMessageVisibility(
    "synchronizationInfoMessage"
  )(state)
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ ...syncActions, toggleMessage }, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(SynchronizationContainer));



// WEBPACK FOOTER //
// ./src/synchronization/index.js